import { css } from 'linaria';

export const selectionBlockInfo = css`
  &&& {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 24px;
    overflow: hidden;
    border-radius: var(--rounding-l);

    @media (--only-tablet) {
      grid-column-start: span 2;
    }

    @media (--only-mobile) {
      height: 218px;
    }

    ::before {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 258px;
      height: 258px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      content: '';
      
      @media (--only-desktop) {
        width: 182px;
        height: 182px;
      }

      @media (--only-mobile) {
        right: -22px;
        width: 128px;
        height: 128px;
      }
    }
  }
`;

export const selectionBlockTitle = css`
  width: 284px;

  @media (--only-mobile) {
    width: 100%;
  }

  && {
    margin-bottom: 12px;

    @media (--only-mobile) {
      font-size: 18px;
      line-height: 24px;
    }
  }
`;

export const selectionBlockText = css`
  && {
    width: 200px;
    line-height: 24px;

    @media (--only-mobile) {
      line-height: 20px;
    }
  }
`;

export const selectionBlockButton = css`
  width: max-content;
  padding: 12px 24px;
  margin-top: auto;
  text-align: center;
  background-color: var(--control-primary);
  border-radius: var(--rounding-m);

  @media (--only-mobile) {
    padding: 10px 20px;
  }

  a:hover & {
    background-color: var(--control-hover-primary);
  }
`;
